function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconCheckmarkCircle from '../../icons/icon_checkmark_circle';
import IconMinusCircle from '../../icons/icon_minus_circle';
import { useItemStyle } from './use_styles';
import { RequirementItemPropTypes } from './prop_types';
import { useTheme } from '@veneer/theme';
import { jsx as ___EmotionJSX } from "@emotion/core";
var RequirementItem = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    status = 'incomplete',
    label
  } = _ref;
  var itemStyles = useItemStyle();
  var theme = useTheme();
  var statusIcon = ___EmotionJSX("div", {
    css: itemStyles.bullet
  });
  var commonIconStyle = {
    filled: true,
    size: theme.passwordRequirements.iconSize
  };
  if (status === 'complete') {
    statusIcon = ___EmotionJSX(IconCheckmarkCircle, _extends({
      customStyle: itemStyles.iconCheck
    }, commonIconStyle));
  }
  if (status === 'error') {
    statusIcon = ___EmotionJSX(IconMinusCircle, _extends({
      customStyle: itemStyles.iconMinus
    }, commonIconStyle));
  }
  return ___EmotionJSX("div", {
    css: itemStyles.item,
    ref: ref
  }, statusIcon, ___EmotionJSX("span", {
    css: itemStyles.text
  }, label));
});
RequirementItem.propTypes = RequirementItemPropTypes;
RequirementItem.displayName = 'PasswordRequirementItem';
export default RequirementItem;